import { type ReactNode } from "react";

import { type DisabledVisibilityOptionConfig, type LensVisibilityConfig } from "./visibilityConfigs";

import { Visibility } from "src/app/gql-generated/types";

export const EXCLUSIVE_LENS_VISIBILITY_OPTIONS = [
    Visibility.VisibilityHidden,
    Visibility.VisibilityOffline,
    Visibility.VisibilityDontPublishToSnapchat,
];

const DEFAULT_EXCLUSIVE_LENS_VISIBILITY_MESSAGE =
    "This option is disabled for the Lens+ Payouts, Lenses must be public.";

export const getExclusiveLensVisibilityOptions = (
    options: Visibility[],
    disabledOptions: Partial<Record<Visibility, DisabledVisibilityOptionConfig>>,
    message: ReactNode = DEFAULT_EXCLUSIVE_LENS_VISIBILITY_MESSAGE,
): Partial<Record<Visibility, DisabledVisibilityOptionConfig>> => {
    const exclusiveLensDisabledOptions = { ...disabledOptions };

    EXCLUSIVE_LENS_VISIBILITY_OPTIONS.forEach((visibility) => {
        if (options.includes(visibility)) {
            exclusiveLensDisabledOptions[visibility] = {
                option: visibility,
                message,
            };
        }
    });

    return exclusiveLensDisabledOptions;
};

/** Applies the visibility restrictions shared by persisted and newly selected Lens+ Lenses. */
export const makeExclusiveLensVisibilityConfig = (
    visibilityConfig: LensVisibilityConfig,
    message?: ReactNode,
): LensVisibilityConfig => ({
    ...visibilityConfig,
    defaultVisibility: Visibility.VisibilityPublic,
    disabledOptions: getExclusiveLensVisibilityOptions(
        visibilityConfig.options,
        visibilityConfig.disabledOptions ?? {},
        message,
    ),
});
